<div class="flex h-full">
  <app-chat-tabs class="flex-1" />
  <app-vehicle-details-sidebar />
</div>

@if (subscriptionExpired()) {
  <div class="absolute inset-0 z-40 overflow-hidden">
    <div class="absolute inset-0 bg-[rgba(0,0,0,0.4)] backdrop-blur-sm"></div>
    <div class="absolute inset-0 flex items-center justify-center">
      @if (authService.userIsAdmin()) {
        <div class="flex max-h-full flex-col overflow-hidden rounded-md bg-white">
          <h2 class="max-w-[650px] px-4 pt-8 text-xl font-bold md:px-8 md:pt-10">
            @if (authService.currentUser()?.subscription?.plan === 'professional' || authService.currentUser()?.subscription?.plan === 'enterprise') {
              {{ 'profile.subscription.modal.headlineExpiredSubscription' | transloco }}
            } @else {
              {{ 'profile.subscription.modal.headlineExpired' | transloco }}
            }
          </h2>

          <div class="mt-2 flex w-full flex-1 overflow-auto px-4 max-md:w-full md:px-8">
            <app-product-list class="mx-auto block h-fit overflow-visible py-8 max-md:flex-1" />
          </div>
        </div>
      } @else {
        <div class="product-list-dialog">
          <app-trial-expired-dialog class="flex flex-1" />
        </div>
      }
    </div>
  </div>
}
